<template>
  <div
    id="signin"
    v-bind:class="{
      'is-loading': state.isLoading,
      'open-modal': state.openModal
    }"
  >
    <div class="loading__overlay loading__overlay--inverse">
      <div class="loading"></div>
    </div>

    <div v-if="!state.formCompleted && !$parent.errorMsg && data">
      <h1 v-if="data && data.branding">
        {{ data.branding.name }} - {{ data.name }}
      </h1>
      <form-builder
        ref="myFormBuilder"
        :steps="steps"
        :callback="submit"
        :hasBack="true"
        :hasNext="hasNext"
        @back="goBack"
      ></form-builder>
    </div>
  </div>
</template>

<script>
import FormBuilder from '@/components/FormBuilder.vue';
import { getCheckInDataMixin } from '@/mixins.js';

export default {
  name: 'SignOut',
  mixins: [getCheckInDataMixin],
  components: {
    FormBuilder
  },
  data() {
    return {
      state: {
        openModal: false,
        isLoading: false,
        activeStep: 0,
        formCompleted: false,
        formCompletedMsg: 'Sorry theres been an error'
      },
      data: null,
      userData: {},
      steps: [
        {
          title: '',
          fields: [],
          footer: null
        }
      ],
      showSubmitFeedback: false,
      hasNext: false,
      qrCodeContent: sessionStorage.getItem("qrCodeContent")
    };
  },
  computed: {},
  // created() {
  //   if (this.$root.location) this.data = this.$root.location;
  // },
  mounted() {
    this.$parent.errorMsg = null;
    console.log('mount');
    this.getLocalPost(this.getLocalPostCallback);
  },
  methods: {
    getLocalPostCallback(userData) {
      this.userData = userData;

      const {visitor} = this.userData;
      const {contactType} = visitor;
      const {rules} = contactType;
      const {host} = rules;
      console.log("host >>> ", host);
      this.hasNext = host === 0 || host === 2;

      if (!userData) {
        this.$parent.errorMsg = 'Please Enter Your Info';
        this.$router.push({
          name: 'signin'
        });
      } else {
        this.getCheckInData(
          this.$route.params.id,
          this.getDataCallback,
          userData
        );
      }
    },
    getDataCallback() {
      let me = this;
      //Check if form sent
      const { questionSet } = ((this.userData.visitor || {}).contactType || {});
      const questions = questionSet && questionSet.questions ? questionSet.questions : this.data.questions;
      if (questions && questions.length > 0) {
        this.steps[0].footer = this.data.terms || (this.data.branding || {}).terms;
        questions.forEach(function(item) {
          //Map Questions to structure
          var step = me.steps[0];
          const config = item.config ? JSON.parse(item.config) : null;
          var newField = {
            type: !item.inputControl ? 'checkbox' : item.inputControl.id,
            label: item.question,
            terms: item.additionalTerms,
            name: '' + item.id,
            rules: { required: item.required },
            value: '',
            config
          };
          // newField.hidden = me.setHiddenAttr(newField)
          step.fields.push(newField);
        });
        console.log("this.steps >>> ", this.steps);
      } else {
        this.submit();
      }
    },
    setFormSent(extraData) {
      console.log('setFormSent');
      this.state.formCompleted = true;
      this.state.formCompletedMsg = extraData.message;

      if (extraData.checkout) {
        this.state.checkoutUrl = extraData.checkout.url;
      }
    },
    submit() {
      console.log('submit');
      this.state.isLoading = true;
      const me = this;
      console.log("me.userData >>> ", me.userData);
      //

      if (this.data.questions && this.data.questions.length > 0) {
        this.steps[0].fields.forEach(function(item) {
          //Map Questions to structure
          me.userData.questions[item.name] = item.value;
          me.$root.userData = me.userData;
        });
      }

      if (
        me.userData.visitor.contactType &&
        me.userData.visitor.contactType.rules &&
        (me.userData.visitor.contactType.rules.host === 0 ||
          me.userData.visitor.contactType.rules.host === 2)
      ) {
        console.log("submit if >>> ");
        this.$router.push({
          name: 'visiting',
          params: { id: this.$route.params.id }
        });
      } else {
        console.log("submit else >>> ");

        this.postCheckInData({
          ...me.userData,
          visitor: {
            ...me.userData.visitor,
            hostedBy: undefined
          },
          ...(this.qrCodeContent && {qr: {data: this.qrCodeContent}})
        });
      }
    },
    goBack() {
      this.$router.push({
        name: 'signin',
        params: {
          id: this.$route.params.id,
          skipScreen: true
        }
      });
    },
    setHiddenAttr(field) {
      if (!field.config) return false;
      if (field.type === 'video') {
        const conditions = field.config.conditions; //
        if (!conditions) return false;
        // eslint-disable-next-line no-unused-vars
        const [videoURL, watchPercentRequired, showTimeline] = conditions;
        if (showTimeline.value) return true;
        return false;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
